import { FormValues } from './FormValues';
import { PAYER_SIGNATURE_OPTION_VALUES } from './payerSignatureOptions';
import {
  TRIP_REQUIRED_FIELD_OPTION_LABELS,
  TRIP_REQUIRED_FIELD_OPTION_VALUES,
} from './PayerSpecificSettings/PayerTripRequiredFieldSettings/tripRequiredFieldOptions';

export const defaultFormValues: FormValues = {
  id: '',
  display_name: '',
  alternate_name: '',
  is_active: true,
  external_id: '',
  website: '',
  ein: '',
  email: '',
  phone_number: '',
  billing_address: null,
  billing_name: '',
  billing_phone_number: '',
  billing_email: '',
  default_trip_address: null,
  dispatcher_notes: '',
  admin_notes: '',
  pickup_default_early_seconds: null,
  pickup_default_late_seconds: null,
  pickup_appointment_early_seconds: null,
  pickup_appointment_late_seconds: null,
  pickup_will_call_early_seconds: null,
  pickup_will_call_late_seconds: null,
  extra_scheduled_pickup_at_seconds: null,
  invoice_due_after_days: null,
  requires_signature_pickup_passenger: {
    value: PAYER_SIGNATURE_OPTION_VALUES.ORG_DEFAULT,
    label: 'Organization Default',
  },
  requires_signature_dropoff_passenger: {
    value: PAYER_SIGNATURE_OPTION_VALUES.ORG_DEFAULT,
    label: 'Organization Default',
  },
  requires_signature_pickup_driver: {
    value: PAYER_SIGNATURE_OPTION_VALUES.ORG_DEFAULT,
    label: 'Organization Default',
  },
  requires_signature_dropoff_driver: {
    value: PAYER_SIGNATURE_OPTION_VALUES.ORG_DEFAULT,
    label: 'Organization Default',
  },
  type: 'broker',
  payer: null,
  can_multiload: true,
  multiloading_partners: [],
  trip_required_fields: {
    passenger_phone_number: {
      value: TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT,
      label:
        TRIP_REQUIRED_FIELD_OPTION_LABELS[
          TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT
        ],
    },
    passenger_weight: {
      value: TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT,
      label:
        TRIP_REQUIRED_FIELD_OPTION_LABELS[
          TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT
        ],
    },
    authorization_id: {
      value: TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT,
      label:
        TRIP_REQUIRED_FIELD_OPTION_LABELS[
          TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT
        ],
    },
    insurance_policy_id: {
      value: TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT,
      label:
        TRIP_REQUIRED_FIELD_OPTION_LABELS[
          TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT
        ],
    },
    payer_passenger_external_id: {
      value: TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT,
      label:
        TRIP_REQUIRED_FIELD_OPTION_LABELS[
          TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT
        ],
    },
    external_trip_id: {
      value: TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT,
      label:
        TRIP_REQUIRED_FIELD_OPTION_LABELS[
          TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT
        ],
    },
    booked_by_name: {
      value: TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT,
      label:
        TRIP_REQUIRED_FIELD_OPTION_LABELS[
          TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT
        ],
    },
    booked_by_phone_number: {
      value: TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT,
      label:
        TRIP_REQUIRED_FIELD_OPTION_LABELS[
          TRIP_REQUIRED_FIELD_OPTION_VALUES.ORG_DEFAULT
        ],
    },
  },
  allow_only_specific_drivers: false,
  allowed_drivers: [],
  allow_only_specific_vehicles: false,
  allowed_vehicles: [],
};
